import { useEffect } from "react";

/**
 * Set document title (and optionally meta description) on route mount.
 * Keeps SPA route titles in sync so tabs, bookmarks and share-preview scrapers
 * see meaningful strings rather than the static landing title.
 */
export default function usePageMeta(title, description) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      const el = document.querySelector('meta[name="description"]');
      if (el) el.setAttribute("content", description);
    }
  }, [title, description]);
}
